module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/homepage/rough-edge-3c38340468e6b76669c17fb0ae2a8a89.png";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/homepage/rough-edge.png
// module id = DjM8
// module chunks = 9